import EmployeeDocumentList from "../../../employee/employee-document-list.tsx/employee-document-list";

const EmployeeDocuments = () => {

    return (
        <div className={'employee-documents'}>
            <EmployeeDocumentList/>
        </div>
    )
}

export default EmployeeDocuments;